import React from 'react'

/**
 * Component to handle the secure payment
 * @param {Object} props
 * @returns {React.ReactNode}
 * @param {Object} props.staticText - Static text translations
 */
function CartSinglePagePaymentSecure ({ staticText }) {
  return (
    <div className="cart-single-page__payment-secure">
      <span className="cart-single-page__payment-secure-icon" />
      <span>{staticText.getIn(['data', 'securePayment'])}</span>
    </div>
  )
}

export default CartSinglePagePaymentSecure
